module.exports = __webpack_public_path__ + "img/20201018_124728.dddbfcb0.jpg";